import type React from 'react';
import type { IconName } from '../ui/Icon';

export type Section = 'me' | 'team' | 'hr' | 'payroll' | 'admin';

/**
 * One entry in the screen registry. The navigator, deep-link config, sidebar, "More" menu and
 * command palette are all generated from these.
 */
export interface ScreenDef {
  /** unique route name, PascalCase, e.g. 'EmployeeDetail' */
  name: string;
  /** page / menu title */
  title: string;
  section: Section;
  icon: IconName;
  /** visible if the user has ANY of these permission keys (values of `P` from @hrms/shared). Omit = every signed-in user. */
  perms?: string[];
  component: React.ComponentType<any>;
  /** web URL path without leading slash, e.g. 'hr/employees/:id'. '' = '/' */
  path: string;
  /** not shown in sidebar / More / palette (detail screens opened with params) */
  hidden?: boolean;
  /** extra words for command-palette search */
  keywords?: string;
}

export const SECTIONS: { key: Section; label: string }[] = [
  { key: 'me', label: 'My space' },
  { key: 'team', label: 'Team' },
  { key: 'hr', label: 'HR' },
  { key: 'payroll', label: 'Payroll' },
  { key: 'admin', label: 'Admin' },
];

/** Params for routes that are not registry screens. */
export type PublicParams = { Login: undefined; Onboarding: { token: string } };
